import { ChangeObjKey, isNil } from 'shared/utils/helpers';

interface IOptions<Query extends Record<string, unknown> = Record<string, unknown>> {
  query?: Query;
  toString: boolean;
}

// overload signatures
export function createUrl(
  to: string,
  options?: ChangeObjKey<IOptions, 'toString', false>,
): URL;

// eslint-disable-next-line no-redeclare
export function createUrl(
  to: string,
  options: ChangeObjKey<IOptions, 'toString', true>,
): string;

// eslint-disable-next-line no-redeclare
export function createUrl<
  Query extends Record<string, unknown> = Record<string, unknown>,
>(to: string, options?: IOptions<Query>) {
  const isValid = isValidUrl(to);

  let url = isValid ? new URL(to) : to;

  if (options?.query) {
    for (const key in options.query) {
      const value = options.query[key];

      if (isValidQueryValue(value)) {
        if (urlGuard(url, isValid)) {
          url.searchParams.set(key, value);
        } else {
          url += url.includes('?') ? `&${key}=${value}` : `?${key}=${value}`;
        }
      }
    }
  }

  return options?.toString && urlGuard(url, isValid) ? url.toString() : url;
}

const isValidUrl = (to: string) => {
  try {
    return Boolean(new URL(to));
  } catch (e) {
    return false;
  }
};

function urlGuard(url: string | URL, isValid: boolean): url is URL {
  return typeof url === 'object' && isValid;
}

function isValidQueryValue(value: unknown): value is string {
  return !isNil(value) && typeof value === 'string';
}
